import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaDiscord, FaChevronDown } from 'react-icons/fa';
import '../css/hero.css';

const Hero = ({ isMuted, onNewsClick }) => {
    const { t } = useTranslation();

    return (
        <section className="hero" id="home">
            <div className="hero-media">
                <video autoPlay loop playsInline muted={isMuted}>
                    <source
                        src="https://pub-dbdf5fcd9e564423b926314e32108c80.r2.dev/trailer/sp_trailer2.mp4"
                        type="video/mp4"
                    />
                    Your browser does not support the video tag.
                </video>
            </div>
            <div className="hero-overlay" />

            <div className="hero-content">
                <span className="hero-eyebrow">{t('hero.eyebrow')}</span>
                <h1 className="hero-title">{t('hero.title')}</h1>
                <p className="hero-subtitle">{t('hero.subtitle')}</p>

                <div className="hero-actions">
                    <a
                        className="sp-btn sp-btn-primary hero-cta"
                        href="https://discord.gg/superpeopleofficial"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FaDiscord size={18} />
                        {t('hero.ctaDiscord')}
                    </a>
                    <button
                        type="button"
                        className="sp-btn sp-btn-ghost hero-cta"
                        onClick={onNewsClick}
                    >
                        {t('hero.ctaNews')}
                    </button>
                </div>

                <div className="hero-stats">
                    <div className="hero-stat">
                        <span className="hero-stat-value">{t('hero.statClassesValue')}</span>
                        <span className="hero-stat-label">{t('hero.statClasses')}</span>
                    </div>
                    <div className="hero-stat">
                        <span className="hero-stat-value">{t('hero.statPlayersValue')}</span>
                        <span className="hero-stat-label">{t('hero.statPlayers')}</span>
                    </div>
                    <div className="hero-stat">
                        <span className="hero-stat-value">{t('hero.statPriceValue')}</span>
                        <span className="hero-stat-label">{t('hero.statPrice')}</span>
                    </div>
                </div>
            </div>

            <button
                type="button"
                className="hero-scroll"
                onClick={onNewsClick}
                aria-label={t('hero.scroll')}
            >
                <span>{t('hero.scroll')}</span>
                <FaChevronDown />
            </button>
        </section>
    );
};

export default Hero;
